<template>
  <div class="pastBox">
    <div ref="dEcharts" id="dEcharts"></div>
  </div>
</template>

<script>

import * as echarts from 'echarts';

export default {
  name: 'dEcharts',
  data() {
    return {
      screenWidth: document.body.clientWidth,
      echartsRadius: [60, 70],
    }
  },
  props: {
    msg: {
      type: Object,
    },
    // 是否wap
    isWap:{
       type:Boolean
    }
  },
  created() {
    if (this.screenWidth < 500) {
      this.echartsRadius = [50, 60];
    };

  },
  mounted() {
    this.myCharts();

  },
  methods: {
    myCharts() {
      var dEcharts = this.$echarts.init(this.$refs.dEcharts);
    
      var data = [
        { name: '多头占比', value: Number(this.msg.SellScale) },
        { name: '空头占比', value: Number(this.msg.BuyScale) },
      ]
      
      var total=data[0].value+data[1].value
      var numMore = ((data[0].value / total) * 100).toFixed(0)
      var numLess = ((data[1].value / total) * 100).toFixed(0)
    
      var option = {
   
        color: ['#D18A1F', '#C9C9CF',],
        graphic: [
          {
            type: "text",
            left: '41%',
            top:'36%',
            z: 10,
            style: {
              text: numLess+'%',
              textAlign: 'center',
              textVerticalAlign: 'middle',
              fill: "#C9C9CF", // 文字颜色
              fontSize: this.isWap ? 20:26, // 文字大小
            },
          },
          {
            type: "text",
            left: '42%',
            top: '44%',
            z:10,
            
            style: {
              text: "空头占比",
              fill: "#C9C9CF", // 文字颜色
              fontSize: 10, // 文字大小
            },
          },
          {
            type: "text",
            right: '44%',
            top: '42%',
            style: {
              text: "/",
              fill: "#C9C9CF", // 文字颜色
              fontSize: 60, // 文字大小
              fontWeight:'normal',
            
            },
            rotation: Math.PI / -4
          },
          {
            type: "text",
            right: '40%',
            top: '54%',
            style: {
              text: numMore+'%',
              fill: "#D18A1F", // 文字颜色
              fontSize: this.isWap ? 20 : 26, // 文字大小

            },
          },

          {
            type: "text",
            right: '42%',
            top: '62%',
            style: {
              text: "多头占比",
              fill: "#D18A1F", // 文字颜色
              fontSize: 10, // 文字大小
            },
          },

        ],
        series: [
         
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      // var option = {
      //   color: ['#24ba61', '#dc3d37'],
      //   backgroundColor: "#fff",
      //   tooltip: {
      //     show: false,
      //   },
      //   legend: {
      //     show: false,
      //   },
      //   toolbox: {
      //     show: false,
      //   },
      //   series: seriesObj,
      // };
      dEcharts.setOption(option);
    }
  }
}
</script>

<style lang="less" scoped>
.pastBox {
  width: 100%;
  height: 100%;

  #dEcharts {
    margin: 0 auto;
    width: 100%;
    height: 100%;
   
  }
}
</style>